import { LeftArrowCarrausolIcon, RightArrowCarrausolIcon } from "assests";
import { useCallback, useEffect, useState } from "react";

export const usePrevNextButtons = (emblaApi) => {
  const [prevBtnDisabled, setPrevBtnDisabled] = useState(true);
  const [nextBtnDisabled, setNextBtnDisabled] = useState(true);

  const onPrevButtonClick = useCallback(() => {
    if (!emblaApi) return;
    emblaApi.scrollPrev();
  }, [emblaApi]);

  const onNextButtonClick = useCallback(() => {
    if (!emblaApi) return;
    emblaApi.scrollNext();
  }, [emblaApi]);

  const onSelect = useCallback((emblaApi) => {
    setPrevBtnDisabled(!emblaApi.canScrollPrev());
    setNextBtnDisabled(!emblaApi.canScrollNext());
  }, []);

  useEffect(() => {
    if (!emblaApi) return;

    onSelect(emblaApi);
    emblaApi.on("reInit", onSelect).on("select", onSelect);
  }, [emblaApi, onSelect]);

  return {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick,
  };
};

export const PrevButton = (props) => {
  const { children, ...restProps } = props;

  return (
    <button
      aria-label="Previous slide"
      className="
        flex justify-center items-center
        w-12 md:w-14 h-12 md:h-14
        rounded-full border border-global-gray-soft
        transition
        bg-global-theme
        text-global-white-default
         disabled:pointer-events-none  disabled:text-global-black-default disabled:bg-transparent disabled:cursor-not-allowed
      "
      type="button"
      {...restProps}
    >
      <LeftArrowCarrausolIcon />
      {children}
    </button>
  );
};

export const NextButton = (props) => {
  const { children, ...restProps } = props;

  return (
    <button
      aria-label="Next slide"
      className="
        flex justify-center items-center border border-global-gray-soft
        w-12 md:w-14 h-12 md:h-14
        rounded-full 
        transition
       bg-global-theme
        text-global-white-default
         disabled:pointer-events-none  disabled:text-global-black-default disabled:bg-transparent disabled:cursor-not-allowed
      "
      type="button"
      {...restProps}
    >
      <RightArrowCarrausolIcon />
      {children}
    </button>
  );
};
